import { Grid, Typography } from "@mui/material";

const colorData = [
  { range: "0 days", color: "#E0F7FA" },
  { range: "1-3 days", color: "#FFF9C4" },
  { range: "4-6 days", color: "#FFE0B2" },
  { range: "7-13 days", color: "#D1C4E9" },
  { range: "14-30 days", color: "#C8E6C9" },
  { range: "31-60 days", color: "#F8BBD0" },
];

export default function ColorCodeTable() {
  return (
    <Grid
      container
      spacing={2}
    >
      {colorData.map((item, index) => (
        <Grid
          item
          xs={12}
          key={index}
          container
        >
            <div  className="justify-content-between d-flex align-items-center w-100 pb-1 ">

          <Typography variant="body1">{item.range}</Typography>
          <div
            style={{
              backgroundColor: item.color,
              width: 100,
              height: 24,
              borderRadius: 4,
              border: "1px solid #ccc",
            }}
          />
            </div>
        </Grid>
      ))}
    </Grid>
  );
}
